module.exports = __webpack_public_path__ + "img/11.197e8bb3.jpg";